import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Image :", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Nom :", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Type de Catégorie :", -1)
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Description :", -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Service :", -1)
const _hoisted_22 = { class: "badge text-outline-info" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Sous catégorie:", -1)
const _hoisted_25 = { key: 4 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Lien :", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-categorieArticles",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.categorie?.urlImage)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForFiles(_ctx.categorie.urlImage),
                        alt: "Image",
                        width: "200",
                        height: "200"
                      }, null, 8, _hoisted_11)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.categorie?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.categorie?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, [
                (_ctx.categorie?.typeCategorie == '0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Service Interne"))
                  : _createCommentVNode("", true),
                (_ctx.categorie?.typeCategorie == '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Service Externe"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.categorie?.description)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", {
                      innerHTML: _ctx.categorie.description
                    }, null, 8, _hoisted_20)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.categorie?.isService), 1)
                ])
              ]),
              (_ctx.categorie?.categorieArticle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("td", null, _toDisplayString(_ctx.categorie?.categorieArticle?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.categorie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("td", null, _toDisplayString(_ctx.categorie?.lienExterne), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}